import { FC } from 'react'

import {
  GenreWithCurators,
  MergedGenres,
} from 'src/Redux/spotifyCampaignGenresApi'

import { SearchGenresList } from './SearchGenresList'
import { RecommendedGenresList } from './RecomendedGenresList'
import { PopularGenresList } from './PopularGenresList'

type SpotifyGenresModalReadyToSelectListsProps = {
  debouncedSearchValue: string
  onSetSelectedGenres: (genre: GenreWithCurators) => void
  selectedGenres: GenreWithCurators[]
  data?: MergedGenres
}
export const SpotifyGenresModalReadyToSelectLists: FC<
  SpotifyGenresModalReadyToSelectListsProps
> = (props) => {
  const { debouncedSearchValue, selectedGenres, data, onSetSelectedGenres } =
    props
  return (
    <>
      {Boolean(debouncedSearchValue) && (
        <SearchGenresList
          searchValue={debouncedSearchValue}
          selectedGenres={selectedGenres}
          genres={data?.allGenres}
          onClickGenre={onSetSelectedGenres}
        />
      )}
      {!debouncedSearchValue && (
        <RecommendedGenresList
          selectedGenres={selectedGenres}
          genres={data?.recommended}
          onClickGenre={onSetSelectedGenres}
        />
      )}
      {!debouncedSearchValue && (
        <PopularGenresList
          selectedGenres={selectedGenres}
          genres={data?.popularGenres}
          onClickGenre={onSetSelectedGenres}
        />
      )}
    </>
  )
}
